import { useMemo, useEffect, useState } from "react";
import {
  useGetAllBuildingsById,
  useGetAllLocationsDropdown,
  useGetAllSystemDetailCodesDropdown,
} from "../common/query";
import { useGetMusterPointsDropdownByLocation } from "./query";
import { SYSTEM_DETAIL_CODES } from "../../constants/common";
import { mapToOptions } from "../../lib/functions";
import { useTranslation } from "react-i18next";

export const useEvacuationData = (
  selectedLocationId?: string,
  selectedBuildingId?: string,
  onInitializeWhoToInclude?: (options: number[]) => void,
  evacuationEvent?: any,
) => {
  const { i18n } = useTranslation();

  const [eventStatus, setEventStatus] = useState({
    statusEn: "",
    statusAr: "",
  });

  const { data: allLocations } = useGetAllLocationsDropdown();
  const { data: allBuildings } = useGetAllBuildingsById({
    encryptedId: selectedLocationId ? selectedLocationId.toString() : "",
  });
  const { data: musterPoints } = useGetMusterPointsDropdownByLocation({
    n_LocationID: selectedLocationId ? Number(selectedLocationId) : 0,
    n_BuildingID: selectedBuildingId ? Number(selectedBuildingId) : 0,
  });
  const { data: allEventTypes } = useGetAllSystemDetailCodesDropdown({
    encryptedId: SYSTEM_DETAIL_CODES.MUSTER_EVENT_TYPE,
  });
  // const { data: allWhoToIncludes } = useGetAllSystemDetailCodesDropdown({
  //   encryptedId: SYSTEM_DETAIL_CODES.EMERGENCY_EVACUATION_PERSON_TYPE,
  // });

  const locations = useMemo(
    () =>
      mapToOptions(
        "s_LocationName_En",
        "s_LocationName_Ar",
        "n_LocationID",
        allLocations,
      ),
    [allLocations],
  );

  const buildings = useMemo(
    () =>
      allBuildings
        ? mapToOptions(
            "s_BuildingName_En",
            "s_BuildingName_Ar",
            "n_BuildingID",
            allBuildings,
          )
        : [],
    [allBuildings],
  );

  const musterPointsOptions = useMemo(() => {
    if (!musterPoints) return [];

    return musterPoints.map(
      (point: {
        n_MusterPointID: number;
        s_MusterPointName_En: string;
        s_MusterPointName_Ar: string;
      }) => ({
        id: point.n_MusterPointID,
        label:
          i18n.language === "en"
            ? point.s_MusterPointName_En
            : point.s_MusterPointName_Ar,
      }),
    );
  }, [i18n.language, musterPoints]);

  const eventTypes = useMemo(
    () => mapToOptions("s_Desc_E", "s_Desc_A", "n_DetailedCode", allEventTypes),
    [allEventTypes],
  );

  // const whoToIncludes = useMemo(
  //   () =>
  //     mapToOptions("s_Desc_E", "s_Desc_A", "n_DetailedCode", allWhoToIncludes),
  //   [allWhoToIncludes],
  // );

  // useEffect(() => {
  //   if (whoToIncludes.length > 0 && onInitializeWhoToInclude) {
  //     onInitializeWhoToInclude(whoToIncludes.map((option) => option.value));
  //   }
  // }, [whoToIncludes, onInitializeWhoToInclude]);

  useEffect(() => {
    if (evacuationEvent) {
      setEventStatus({
        statusEn: evacuationEvent.s_Status_En,
        statusAr: evacuationEvent.s_Status_Ar,
      });
    }
  }, [evacuationEvent]);

  return {
    locations,
    buildings,
    musterPointsOptions,
    eventTypes,
    // whoToIncludes,
    eventStatus,
  };
};
